import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Field } from 'react-final-form';
import { FORM_GUESTS } from 'src/listing/constants';
import Label from 'src/common/components/Label';
import NumberInput from 'src/common/components/NumberInput';
import { useTripCartOptionsContext } from 'src/trip-cart/hooks/useTripCartOptionsContext';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './TripCartGuests.module.scss';

type TripCartGuestsProps = {
  inSheet?: boolean;
  alignRight?: boolean;
};

const TripCartGuests: FC<TripCartGuestsProps> = ({ inSheet, alignRight }) => {
  const [t] = useTranslation('listing-page');
  const { options } = useTripCartOptionsContext();
  const inlineLabel = !!inSheet;

  return (
    <div className={getClassNames(styles, 'root', classNames({ inlineLabel, alignRight }))}>
      <Field name={FORM_GUESTS}>
        {({ input }) => (
          <>
            <div className={styles.label}>
              <Label
                label={t('trip-cart--number-of-guests')}
                htmlFor={FORM_GUESTS}
                inlineSlot={t('trip-cart--max-capacity', { capacity: options.formGuests })}
                size="m"
                compact={inlineLabel}
                required
              />
            </div>
            <div className={styles.number}>
              <NumberInput
                id={FORM_GUESTS}
                // Always use 1 to ensure form is valid
                min={1}
                max={options.formGuests}
                value={input.value}
                onChange={input.onChange}
                onBlur={input.onBlur}
                size={inSheet ? 'l' : 'm'}
                data-test="guest"
                smallButtonsOnMobile
              />
            </div>
          </>
        )}
      </Field>
    </div>
  );
};

export default TripCartGuests;
